import PropTypes from 'prop-types';
import { breakpoints, Card, Inline, Stack, Text, textVariants, vars } from '@etg/wings';
import { Accordion } from '@eti/components';
import { useDateFormat, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { BoundNew } from '@eti/types';
import { date as dateUtil } from '@eti/utils';
import { TripType } from '@eti/schema-types';
import { getBoundTitle, getBoundType } from '../../../../../../widgets/trip-details/utils/format';
import { useOrderDetails } from '../../../../containers/OrderDetailsContext';
import Segment from './Segment';
import { isBoundInThePast } from './utils/utils';

const accordionHeaderInlineStyles = css`
  @media (min-width: ${breakpoints._560}) {
    align-items: center;
  }
`;

const secondaryInfoStyles = css`
  color: #737373;
  text-align: start;
`;

const accordionWrapperStyles = css`
  border: 1px solid ${vars.colors.divider};
  border-radius: 3px;
`;

const Bound = ({ bound, index }) => {
  const { t } = useTranslation();
  const { day } = useDateFormat();
  const { journeyType } = useOrderDetails();
  const isMultiStop = journeyType === TripType.MultiStop;
  const today = new Date();
  const boundType = getBoundType(index);
  const title = t(getBoundTitle(boundType, isMultiStop), index + 1);
  const dataTestIdPrefix = `checkin-bound-${bound.boundId}`;

  return (
    <div className={accordionWrapperStyles} data-testid={dataTestIdPrefix} role="listitem">
      <Accordion
        id={`${dataTestIdPrefix}-accordion`}
        isInitiallyExpanded={bound.isUpcoming}
        variant="full-width"
      >
        <Card>
          <Accordion.Header>
            <Stack spacing={4}>
              <div className={secondaryInfoStyles} data-testid={`${dataTestIdPrefix}-date`}>
                {dateUtil.format(bound.segments[0].departuredAt, day)}
              </div>
              <Inline
                className={accordionHeaderInlineStyles}
                collapseBelow={breakpoints._560}
                spacing={{ [breakpoints._0]: 4, [breakpoints._560]: 16 }}
              >
                <Text
                  data-testid={`${dataTestIdPrefix}-title`}
                  variant={textVariants._18_EMPHASIZED}
                >
                  {title}
                </Text>
                {isBoundInThePast(bound, today) && (
                  <div
                    className={secondaryInfoStyles}
                    data-testid={`${dataTestIdPrefix}-past-event`}
                  >
                    {t('OrderDetails.CheckIn.Purchased.PastEvent.Text')}
                  </div>
                )}
              </Inline>
            </Stack>
          </Accordion.Header>
        </Card>
        <Accordion.Body>
          {bound.segments.map((segment) => (
            <Segment
              boundId={bound.boundId}
              key={`checkin-bound-${bound.boundId}-segment-${segment.segmentId}`}
              segment={segment}
            />
          ))}
        </Accordion.Body>
      </Accordion>
    </div>
  );
};

Bound.propTypes = {
  bound: BoundNew,
  index: PropTypes.number,
};

export default Bound;
